import { createAction } from '@reduxjs/toolkit'

export const fetchOverallRiskAssessment = createAction("FETCH_OVERALL_RISK_ASSESSMENT_SAGA")
export const fetchRiskAssessmentByYE9 = createAction("FETCH_RISK_ASSESSMENT_BY_YE9_SAGA")
export const fetchOverallFlagCounts = createAction("FETCH_OVERALL_FLAG_COUNTS_SAGA")
export const fetchStudentsWithFlagsCounts = createAction("FETCH_STUDENTS_WITH_FLAGS_COUNTS_SAGA")
export const fetchFlagCountsByCampus = createAction("FETCH_FLAG_COUNTS_BY_CAMPUS_SAGA")
export const fetchFlagCountsByYE9 = createAction("FETCH_FLAG_COUNTS_BY_YE9_SAGA")
export const fetchFlagCountsByDem = createAction("FETCH_FLAG_COUNTS_BY_DEM_SAGA")
